import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActionsSubject, Store, select } from '@ngrx/store';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { catchError, filter, take, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppState } from './app.states';
import { AuthActions } from './features/authentication/state/auth.action-types';
import { isLoggedIn, showPop } from './features/authentication/state/auth.selectors';
import { GAService } from './shared/services/ga.service';
import { MixpanelService } from './shared/services/mixpanel.service';
import { SharedActions } from './shared/state/shared.action-types';
import { sideMenuVisibility, toggleMenuVisibility } from './shared/state/shared.selectors';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Toaster } from 'ngx-toast-notifications';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event as RouterEvent,
} from '@angular/router';
import { createPopup } from '@typeform/embed';
import Big from 'big.js';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from './features/users/services/users.service';
import { UsersActions } from './features/users/state/users.action-types';
import { UsersSelectors } from './features/users/state/users.selector-types';
import { ClientLegalInformationComponent } from './shared/UI/organisms/client-legal-information/client-legal-information.component';
import { debounce } from './shared/controls/decorators/debounce.decorator';
import { LaftStatus } from './shared/enums/LaftStatus.enum';
import { Roles } from './shared/enums/Roles.enum';
import { OverlayService } from './shared/modules/overlay/services/overlay.service';
import { GTMService } from './shared/services/gtm.service';
import { WindowScrollService } from './shared/services/window-scroll.service';
import { InvestorCompleteProfileComponent } from './shared/UI/organisms/investor-complete-profile-dialog/investor-complete-profile-dialog.component';
import { UserStatus } from './shared/enums/UserStatus.enum';
import { LaftModalComponent } from './shared/UI/organisms/laft-profile/laft-modal/laft-modal.component';
import { LaftService } from './shared/services/laft.service';
import { InvestorAccountApprovedComponent } from './shared/UI/organisms/investor-account-approved-dialog/investor-account-approved-dialog.component';
import { PendingValidationPopupComponent } from './shared/UI/organisms/pending-validation-popup/pending-validation-popup.component';
import { LaftKeynuaQrModalComponent } from './shared/UI/organisms/laft-profile/laft-keynua-qr/laft-keynua-qr.component';
import { LaftKeynuaWidgetModalComponent } from './shared/UI/organisms/laft-profile/laft-keynua-widget/laft-keynua-widget.component';
import { SocketService } from './shared/services/socket.service';
import { IdType } from './shared/enums/IdType.enum';
import { FeatureFlagService } from './shared/services/feature-flag.service';
import { PreApprovalPopupService } from './shared/services/pre-approval-popup.service';
import {
  LaftBannerColumn,
  LaftStatusBannerAction,
  LaftStatusBannerService,
  LaftStatusBannerState,
} from './shared/services/laft-status-banner.service';
import {
  LaftStatusBannerCopy,
  laftStatusBannerCopy as resolveLaftStatusBannerCopy,
} from './shared/constants/laft-status-banner.copy';
import { PreApprovedDepositPopupComponent } from './shared/UI/organisms/pre-approved-deposit-popup/pre-approved-deposit-popup.component';
import {
  BANK_ACCOUNT_CREATE_ROUTE,
  DEPOSIT_ROUTE,
} from './shared/constants/deposit-funnel.routes';
import { datadogRum } from '@datadog/browser-rum';
import { LaftLegalModalComponent } from './shared/UI/organisms/laft-profile-legal/laft-legal-modal/laft-legal-modal.component';
import { LaftCompanyKeynuaQrComponent } from './shared/UI/organisms/laft-profile-legal/laft-company-keynua-qr/laft-company-keynua-qr.component';
import { ClientContractDialogComponent } from './shared/UI/organisms/client-contract-dialog/client-contract-dialog.component';
import { NewContractPopupComponent } from './shared/UI/organisms/new-contract-popup/new-contract-popup.component';
import { shouldShowNewContractPopup } from './shared/utils/contract-version.util';
import { InvertorResidencyDialogComponent } from './shared/UI/organisms/invertor-residency-dialog/invertor-residency-dialog.component';
import { LAFT_HISTORY_ACTIONS } from './shared/constants/laft-declaration-history.actions';
import { ChooseDocumentsSignPopupComponent } from './shared/UI/organisms/choose-documents-sign-popup/choose-documents-sign-popup.component';
import { SignDocumentTypes } from './shared/UI/organisms/choose-documents-sign-popup/sign-document-types.enum';
import { OnboardingService } from './shared/services/onboarding.service';
import { ContractService } from './shared/services/contract.service';
import { showToast } from './shared/util/toaster.util';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  @HostListener('window:scroll', ['$event'])
  @debounce()
  onScrollEvent($event) {
    this.windowScrollService.scrollY.next(this.calculatePercentageScroll());
  }
  ngUnsubscribe: Subject<void> = new Subject<void>();
  isLoggedIn$: Observable<boolean>;
  showPopUp$: Observable<boolean>;
  actions$: Observable<any>;
  isSideMenuVisible$: Observable<boolean>;
  isMobile;
  isAdmin$: Observable<boolean>;
  isRisk$: Observable<boolean>;
  subsc;
  profile;
  showPopUp;
  clickEventsubscription;
  checkedByDefault;
  loading = false;
  resourceURI;
  pageTitle;
  toogleCurrency = 'PEN';
  displayFeeback = false;
  private datadogInitialized = false;
  stepsSetupBar = [
    {
      title: 'Crear cuenta',
    },
    {
      title: 'Verificar correo',
    },
    {
      title: 'Subir factura',
      url: '/invoices/create',
    },
    {
      title: 'Firmar contrato',
    },
  ];

  stepsSetupBarInvestor = [
    {
      title: 'Crear cuenta',
    },
    {
      title: 'Verificar correo',
    },
    {
      title: 'Añadir cuenta bancaria',
      url: '/bank-accounts/create',
    },
    {
      title: 'Realizar depósito',
      url: '/financial-transactions/deposit',
    },
    {
      title: '¡Invertir!',
      url: '/opportunities',
    },
  ];
  stepsSetupBarGeneral;
  currenStepSetupBar = 2;
  titleSetupBar = '¡Termina tu registro!';
  displayCloseButton = false;
  hideByDefault = false;
  currentRoute;
  hideSetup = false;
  pageScroll = 0;
  lastScroll = 0;
  scrollY$: Observable<number>;
  defaultLauncherEvent$: Observable<boolean>;
  scrollTo;
  bodyScrollTo;
  scrollHeight;
  clientHeight;
  range_25 = false;
  range_50 = false;
  range_75 = false;
  range_100 = false;
  sectionTitle;
  toogleCurrencyInvestment = 'PEN';
  activeTab;
  pageCurrency;
  toogleCurrencyTransactions;
  userData;
  routeURL;
  previousUrl;
  showCompleteProfile = false;
  showPendingProfile = false;
  showApproveAccountProfile = false;
  showPreApprovedDepositPopup = false;
  // FIN-1708 · the signing URL the submit returned. `laftData` is fetched separately
  // and may not have arrived when the investor presses *Firmar ahora*, so this is the
  // only synchronous source of it at that moment.
  private pendingKeynuaUrl: string | null = null;
  laftData;
  laftWaitingForRealtimeAfterPepSubmit = false;
  private laftPepSubmitRefreshTimeout: ReturnType<typeof setTimeout> | null = null;
  /** After POST pending-contracts signature: wait for `contract_status` → signature requested (ContractUpdateEvent on BE). */
  private pendingContractsSignatureAwaitingSocket = false;
  private pendingContractsSignatureSocketTimeout: ReturnType<typeof setTimeout> | null = null;
  roles = Roles;
  userStatus = UserStatus;
  ENVIRONMENT = environment;
  private laftModalDialog: MatDialogRef<LaftModalComponent>;
  private laftLegalModalDialog: MatDialogRef<LaftLegalModalComponent>;
  laftKeynuaDialog: MatDialogRef<LaftKeynuaQrModalComponent>;
  laftKeynuaWidgetDialog: MatDialogRef<LaftKeynuaWidgetModalComponent>;
  laftCompanyKeynuaDialog: MatDialogRef<LaftCompanyKeynuaQrComponent>;
  private clientContractDialog: MatDialogRef<ClientContractDialogComponent>;
  private newContractPopupRef: MatDialogRef<NewContractPopupComponent>;
  laftStatus = LaftStatus.Pending;
  clientOnboardingAwaitingInReview = false;
  private clientOnboardingAwaitingInReviewTimeout: ReturnType<typeof setTimeout> | null = null;
  private clientOnboardingSpinnerKeepAliveInterval: ReturnType<typeof setInterval> | null = null;

  onboardingBannerHasData = false;
  onboardingBannerIsFullyCompleted = false;

  constructor(
    private gtmService: GTMService,
    private breakpointObserver: BreakpointObserver,
    private store: Store<AppState>,
    private router: Router,
    private spinner: NgxSpinnerService,
    private mixPanelService: MixpanelService,
    public dialog: MatDialog,
    private userService: UsersService,
    private actionsSubj: ActionsSubject,
    private overlayService: OverlayService,
    private route: ActivatedRoute,
    private gaService: GAService,
    private windowScrollService: WindowScrollService,
    private laftService: LaftService,
    private socketService: SocketService,
    private featureFlagService: FeatureFlagService,
    private preApprovalPopup: PreApprovalPopupService,
    private laftStatusBanner: LaftStatusBannerService,
    private onboardingService: OnboardingService,
    private contractService: ContractService,
    private cdr: ChangeDetectorRef,
    private toaster: Toaster,
  ) {
    this.router.events.subscribe((e: RouterEvent) => {
      this.navigationInterceptor(e);
    });

    this.clickEventsubscription = this.userService.getClickEvent().subscribe(() => {
      this.showModal();
    });
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.routeURL = event.url;
      this.spinner.show();
    }
    if (event instanceof NavigationEnd) {
      this.routeURL = event.url;
      this.previousUrl = this.currentRoute;
      this.currentRoute = event.url;
      this.store.dispatch(SharedActions.HideSideMenu());
      this.spinner.hide();
      this.gtmService.pageView(event.url);
      this.resourceURI = event.url;
      this.getCurrentToggle();
      this.getTitlePage();
      this.resetRange();
      this.sendEventPageView();
      this.hideOnSubpages(event.url);
      this.defaultLauncher();
      this.windowScrollService.setPreviousUrl(this.previousUrl);
    }
    if (event instanceof NavigationCancel) {
      this.routeURL = event.url;
      this.store.dispatch(SharedActions.HideSideMenu());
      this.spinner.hide();
    }
    if (event instanceof NavigationError) {
      this.routeURL = event.url;
      this.store.dispatch(SharedActions.HideSideMenu());
      this.spinner.hide();
    }
  }

  ngOnInit() {
    Number.prototype.toFixed = function (digits = 2) {
      const precision = Math.pow(10, digits);
      let number = String(
        (Math.sign(Number(this)) * Math.round(Math.abs(Number(this)) * precision + 0.00000000001)) / precision
      );

      if (digits !== 0) {
        let trailingZeros = 0;
        if (!number.includes('.')) {
          number += '.';
          trailingZeros = number.length + digits;
        } else {
          trailingZeros = number.split('.')[0].length + 1 + digits;
        }

        number = number.padEnd(trailingZeros, '0');
      }

      return number;
    };

    Big.prototype.toFixed = function (digits = 2) {
      const precision = Math.pow(10, digits);
      let number = String(
        (Math.sign(Number(this)) * Math.round(Math.abs(Number(this)) * precision + 0.00000000001)) / precision
      );

      if (digits !== 0) {
        let trailingZeros = 0;
        if (!number.includes('.')) {
          number += '.';
          trailingZeros = number.length + digits;
        } else {
          trailingZeros = number.split('.')[0].length + 1 + digits;
        }

        number = number.padEnd(trailingZeros, '0');
      }

      return number;
    };

    this.mixPanelService.initialize();
    this.gaService.initialize();
    this.isAdmin$ = this.store.select(UsersSelectors.isAllowed());

    this.store.pipe(select(showPop)).subscribe(data => {
      this.showPopUp = data;
    });

    this.featureFlagService.flags$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(flags => {
      // console.log('[Datadog] LAFT Feature Flag:', flags.laftFeatureEnabled);

      if (
        flags.laftFeatureEnabled &&
        !this.datadogInitialized &&
        (this.ENVIRONMENT.name === 'staging' || this.ENVIRONMENT.name === 'production')
      ) {
        console.log('[Datadog] Inicializando Session Replay...');
        this.initSessionReplay();
        this.datadogInitialized = true;
      }
    });

    this.store
      .select(UsersSelectors.profile())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(profile => {
        if (profile) {
          this.profile = profile;
          if (
            shouldShowNewContractPopup(profile) &&
            !this.newContractPopupRef &&
            this.featureFlagService.isCostoSinIgvPlusOneEnabled()
          ) {
            this.openNewContractPopup();
            return;
          }
          if (
            this.clientOnboardingAwaitingInReview &&
            profile?.role === Roles.CLIENT &&
            profile?.status === UserStatus['In Review']
          ) {
            this.clearClientOnboardingAwaitingInReview();
          }
          if (this.profile.role === 'client') {
            this.setCurrentStep();
          }

          if (this.profile.role === 'investor') {
            this.setCurrentStepInvestor();
          }
          if (
            this.profile.role === 'client' &&
            !this.profile.legalRep &&
            this.profile.legalCounter < 5 &&
            this.showPopUp !== undefined &&
            this.showPopUp
          ) {
            this.showModal();
          }

          if (
            !this.featureFlagService.isLAFTEnabled() &&
            this.profile.gettingFromAPi &&
            this.profile.role === 'investor' &&
            (!this.profile.hasOwnProperty('taxResidency') || this.profile.taxResidency === '') &&
            this.profile.idType != 'ruc'
          ) {
            this.showTaxRetentionModal();
          }

          this.userData = `user_id=${this.profile._id}, name=${this.profile.firstName}`;
          if (
            profile?.role === 'investor' &&
            profile.firstLogin === false &&
            profile.incompleteProfile === true &&
            (profile?.idType === IdType.RUC
              ? this.featureFlagService.isLAFTJuridicaEnabled()
              : this.featureFlagService.isLAFTEnabled())
          ) {
            this.showCompleteMyProfileModal();
          }

          if (
            profile?.role === 'investor' &&
            profile.incompleteProfile === false &&
            profile.status === UserStatus.Approved &&
            profile.userAccountApprovePopUp === false &&
            (profile?.idType === IdType.RUC
              ? this.featureFlagService.isLAFTJuridicaEnabled()
              : this.featureFlagService.isLAFTEnabled()) &&
            !this.isEarlyDepositPersonaNatural(profile)
          ) {
            this.showApprovedAccountModal();
          }

          if (
            profile?.role === 'client' &&
            profile.status === UserStatus.Approved &&
            profile.userAccountApprovePopUp === false &&
            this.featureFlagService.isLAFTClientEnabled()
          ) {
            console.log('showApprovedAccountModal');
            this.showApprovedAccountModal();
          }

          if (
            profile?.role === 'investor' &&
            this.featureFlagService.isLAFTEnabled() &&
            ((profile.incompleteProfile === false && profile.status === UserStatus['Email Verified']) ||
              (profile.status === UserStatus['Email Verified'] && profile.hasLaftProfileError) ||
              (profile.incompleteProfile === true && profile.status === UserStatus['Email Verified']))
          ) {
            this.getLaftData();
          }
          if (
            profile?.role === 'investor' &&
            this.featureFlagService.isLAFTJuridicaEnabled() &&
            (profile.incompleteProfile === true || profile.status === UserStatus['In Review'])
          ) {
            this.getLaftData();
          }

          if (
            profile?.role === Roles.CLIENT &&
            this.featureFlagService.isLAFTClientEnabled()) {
            this.getLaftData();
          }

        }
      });

    this.store.select(UsersSelectors.profile()).subscribe(profile => {
      if (profile) {
        this.profile = profile;

        this.featureFlagService.identifyUser(profile);

        if (profile._id && this.datadogInitialized) {
          this.setDatadogUser(profile);
        }

        if (
          profile?.role === 'investor' &&
          profile.status === UserStatus.Pending &&
          profile.incompleteProfile === false &&
          profile.userAccountPendingPopUp === false &&
          (profile?.idType === IdType.RUC
            ? this.featureFlagService.isLAFTJuridicaEnabled()
            : this.featureFlagService.isLAFTEnabled()) &&
          !this.isEarlyDepositPersonaNatural(profile)
        ) {
          this.showPendingAccountModal();
        }

        if (
          profile?.role === 'client' &&
          profile.status === UserStatus.Pending &&
          profile.incompleteProfile === false &&
          profile.userAccountPendingPopUp === false &&
          this.featureFlagService.isLAFTClientEnabled()
        ) {
          this.showPendingAccountModal();
        }
      }
    });

    this.featureFlagService.flags$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(flags => {
      if (
        flags.laftJuridicaFeatureEnabled &&
        this.profile?.role === 'investor' &&
        this.profile?.idType === IdType.RUC &&
        (this.profile.incompleteProfile === true || this.profile.status === UserStatus['In Review'])
      ) {
        this.getLaftData();
      }
    });

    // Realtime bus (SocketService): same pattern as laft_status / contract_status → onboarding-banner
    this.socketService.socketEvent.pipe(takeUntil(this.ngUnsubscribe)).subscribe(event => {
      console.log('[AppComponent][socketEvent] received:', JSON.stringify(event));
      console.log('[AppComponent][socketEvent] state:', {
        type: event?.type,
        payload: event?.payload,
        pendingContractsSignatureAwaitingSocket: this.pendingContractsSignatureAwaitingSocket,
        laftCompanyKeynuaDialog: !!this.laftCompanyKeynuaDialog,
      });

      // condition: reloadLaftData
      console.log('[AppComponent][socketEvent] check reloadLaftData → type match:', event?.type === 'reloadLaftData');
      if (event?.type === 'reloadLaftData') {
        console.log('[AppComponent][socketEvent] → ENTERED reloadLaftData');
        this.getLaftData();
      }

      // condition: contract_status + SignatureRequested + awaiting socket
      console.log('[AppComponent][socketEvent] check contract SignatureRequested →', {
        typeMatch: event?.type === 'contract_status',
        statusMatch: event?.payload?.contractStatus === LaftStatus.SignatureRequested,
        awaitingSocket: this.pendingContractsSignatureAwaitingSocket,
      });
      if (
        event?.type === 'contract_status' &&
        event?.payload?.contractStatus === LaftStatus.SignatureRequested &&
        this.pendingContractsSignatureAwaitingSocket
      ) {
        console.log('[AppComponent][socketEvent] → ENTERED contract SignatureRequested handler');
        this.onPendingContractsSignatureReadyFromSocket();
      }

      // condition: contract_status + Signed + dialog open
      console.log('[AppComponent][socketEvent] check contract Signed →', {
        typeMatch: event?.type === 'contract_status',
        statusMatch: event?.payload?.contractStatus === LaftStatus.Signed,
        dialogOpen: !!this.laftCompanyKeynuaDialog,
      });
      if (
        event?.type === 'contract_status' &&
        event?.payload?.contractStatus === LaftStatus.Signed &&
        this.laftCompanyKeynuaDialog
      ) {
        console.log('[AppComponent][socketEvent] → ENTERED contract Signed handler — closing laftCompanyKeynuaDialog');
        this.laftCompanyKeynuaDialog.close();
      }

      // condition: laft_status + Completed + dialog open
      console.log('[AppComponent][socketEvent] check laft_status Completed →', {
        typeMatch: event?.type === 'laft_status',
        statusMatch: event?.payload?.laftStatus === LaftStatus.Completed,
        dialogOpen: !!this.laftCompanyKeynuaDialog,
      });
      if (
        event?.type === 'laft_status' &&
        event?.payload?.laftStatus === LaftStatus.Completed &&
        this.laftCompanyKeynuaDialog
      ) {
        console.log('[AppComponent][socketEvent] → ENTERED laft_status Completed handler — closing laftCompanyKeynuaDialog');
        this.laftCompanyKeynuaDialog.close();
      }
    });

    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });

    const existingSession = localStorage.getItem('access_token');
    if (existingSession) {
      this.store.dispatch(
        AuthActions.RestoreSession({
          token: existingSession,
        })
      );
    }

    this.isLoggedIn$ = this.store.pipe(select(isLoggedIn));
    this.isSideMenuVisible$ = this.store.pipe(select(sideMenuVisibility));

    this.store.pipe(select(toggleMenuVisibility)).subscribe(showToggle => {
      this.checkedByDefault = showToggle;
    });

    this.windowScrollService.scrollY$.subscribe(scroll => {
      if (scroll) {
        // check if it is scroll down
        this.trackScroll(scroll);
        this.lastScroll = this.scrollTo;
      }
    });

    this.windowScrollService.defaultLauncherEvent$.subscribe(state => {
      this.displayFeeback = state;
    });

    this.getCurrentToggle();
    //console.log(this.toogleCurrency)
    //Get new page view event from subcomponents, now is signup component only
    this.windowScrollService.getNewEvent().subscribe(data => {
      // console.log(data, this.activeTab)
      this.pageTitle = data.pageTitle;
      this.sectionTitle = data.pageSection;

      if (data.activeTab) this.activeTab = data.activeTab;
      if (data.pageCurrency) this.pageCurrency = data.pageCurrency;

      this.sendEventPageView();
    });

    this.windowScrollService.onClickFeedback().subscribe(data => {
      this.openTypeform();
    });
  }

  showTaxRetentionModal() {
    if (!this.loading) {
      this.loading = true;
      let dialogRef = this.openDialogHelperNotClose(InvertorResidencyDialogComponent);
      this.connectDialogListeners(dialogRef, result => {
        if (result !== 'closed') {
          this.overlayService.startConfirmationModal(
            result,
            null,
            'resultOnly',
            'editOwn',
            null,
            UsersActions.SavingProfile,
            '/profile-settings',
            UsersSelectors.savingProfileSuccessState,
            {
              onSuccess: {
                showCheck: true,
                title: '¡Eso ha sido todo!',
                message:
                  'Puedes revisar y modificar los datos ingresados en la sección <span class="link">"Mis datos personales"</span>',
              },
            }
          );
        } else {
          this.loading = false;
        }
      });
    }
  }

  initSessionReplay() {
    datadogRum.init({
      applicationId: '41c9c552-16eb-4703-8614-91fcdd23691e',
      clientToken: 'pub69e735939308764fe72164c3504216f5',
      site: 'datadoghq.com',
      service: 'finsmart-web',
      env: environment.name,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackBfcacheViews: true,
      defaultPrivacyLevel: 'allow',
    });
  }

  setDatadogUser(profile: any) {
    datadogRum.setUser({
      id: profile._id,
      name: profile.names,
      email: profile.email,
      role: profile.role,
    });
  }

  openTypeform() {
    const baseUrl = environment.clientUrl;
    const existingSession = localStorage.getItem('access_token');
    if (existingSession) {
      const pop = createPopup('kEqFv5UH', {
        width: 500,
        height: 500,
        hidden: {
          userid: this.profile?._id || '',
          username: this.getTypeformUserName(),
          role: this.profile?.role || '',
          pageurl: baseUrl + this.resourceURI || '',
        },
        keepSession: false,
      });

      pop.open(); // call open() on created popup
    }
    const entity = {
      feedbackAnimationClosed: true,
    };
    this.store.dispatch(UsersActions.SavingProfile({ entity: entity, mode: 'editOwn' }));
    this.store.dispatch(UsersActions.LoadProfile());
  }

  getTypeformUserName() {
    if (this.profile.role == 'client') {
      return this.profile.companyName;
    } else {
      return (this.profile.names ? this.profile.names + ' ' : '') + (this.profile?.familyNames || '');
    }
  }

  getLaftData() {
    const laft$ =
      this.profile?.role === Roles.CLIENT
        ? this.laftService.getClientData()
        : this.laftService.getData();
    laft$.subscribe(data => {
      this.laftData =
        this.profile?.role === Roles.CLIENT
          ? { ...data.LAFTData, taxReport: data.taxReport, taxReportFileName: data.taxReportFileName }
          : data.LAFTData;
    });
  }
  hideOnSubpages(url) {
    if (
      url !== '/invoices' &&
      url !== '/my-clients' &&
      url !== '/my-suppliers' &&
      url !== '/bank-accounts' &&
      url !== '/profile-settings' &&
      url !== '/opportunities' &&
      url !== '/my-investments' &&
      url !== '/financial-transactions'
    ) {
      this.hideSetup = true;
    } else {
      this.hideSetup = false;
    }
  }

  ngAfterViewInit() {
    this.gtmService.platformReady();
    if (localStorage.getItem('cleanUrlOnReload') === 'true') {
      this.router.navigateByUrl('/opportunities', { replaceUrl: true });
      localStorage.removeItem('cleanUrlOnReload');
    }
  }

  openDialogHelper(dialogComp, data?) {
    const dialogRef = this.dialog.open(dialogComp, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: 'auto',
      id: 'my-dialog',
      data: data,
      disableClose: true,
    });

    return dialogRef;
  }

  openDialogHelperNotClose(dialogComp, data?) {
    const dialogRef = this.dialog.open(dialogComp, {
      maxWidth: '90vw',
      maxHeight: '100vh',
      height: 'auto',
      id: 'my-dialog-residency',
      data: data,
      disableClose: true,
      autoFocus: false,
    });

    return dialogRef;
  }

  openDialogCompleteProfile(dialogComp, data?) {
    const dialogRef = this.dialog.open(dialogComp, {
      maxHeight: '100vh',
      height: 'auto',
      id: 'complete-profile',
      data: data,
      disableClose: false,
      autoFocus: false,
    });

    return dialogRef;
  }

  showModal() {
    if (!this.loading) {
      this.loading = true;
      let dialogRef = this.openDialogHelper(ClientLegalInformationComponent);
      this.sendEvent();
      this.connectDialogListeners(dialogRef, result => {
        if (result !== 'closed') {
          if (result.legalComment === '') {
            delete result.legalComment;
          }
          this.overlayService.startConfirmationModal(
            result,
            null,
            'resultOnly',
            'editOwn',
            null,
            UsersActions.SavingProfile,
            '/profile-settings',
            UsersSelectors.savingProfileSuccessState,
            {
              onSuccess: {
                showCheck: true,
                title: '¡Gracias!',
                message: 'Puedes revisar tu información en la sección <span class="link">Mis datos personales.</span>',
              },
            }
          );
        } else {
          this.loading = false;
        }
      });
    }
  }

  showCompleteMyProfileModal() {
    if (!this.showCompleteProfile) {
      this.showCompleteProfile = true;
      const entity = {
        firstLogin: true,
      };
      this.store.dispatch(UsersActions.SavingProfile({ entity: entity, mode: 'editOwn' }));
      this.store.dispatch(UsersActions.LoadProfile());
      const dialogRef = this.openDialogCompleteProfile(
        InvestorCompleteProfileComponent
      ) as MatDialogRef<InvestorCompleteProfileComponent>;
      if (dialogRef.componentInstance) {
        dialogRef.componentInstance.idType = this.profile?.idType as IdType;
      }
      this.connectDialogListeners(dialogRef, result => {
        if (result === 'open_laft_form') {
          this.laftService.logLaftDeclarationAction(
            LAFT_HISTORY_ACTIONS.COMPLETAR_POPUP.action,
            LAFT_HISTORY_ACTIONS.COMPLETAR_POPUP.actionDescription,
            this.laftData?._id ?? undefined
          );
          if (this.profile?.idType === IdType.RUC) {
            this.openLaftLegalModal();
          } else {
            this.openLaftModal();
          }
        } else {
          this.laftService.logLaftDeclarationAction(
            LAFT_HISTORY_ACTIONS.CERRAR_POPUP.action,
            LAFT_HISTORY_ACTIONS.CERRAR_POPUP.actionDescription,
            this.laftData?._id ?? undefined
          );
          this.showCompleteProfile = false;
        }
      });
    }
  }

  // FIN-1735 · D138 — a persona natural inside the early-deposit rollout. Both account-status
  // popups are suppressed for them; persona jurídica and clients keep both (AC3).
  private isEarlyDepositPersonaNatural(profile: any): boolean {
    return (
      profile?.role === Roles.INVESTOR &&
      profile?.idType !== IdType.RUC &&
      this.featureFlagService.isEarlyDepositEnabled()
    );
  }

  showApprovedAccountModal() {
    if (!this.showApproveAccountProfile) {
      this.showApproveAccountProfile = true;
      let dialogRef = this.openDialogCompleteProfile(
        InvestorAccountApprovedComponent
      ) as MatDialogRef<InvestorAccountApprovedComponent>;
      if (dialogRef.componentInstance) {
        dialogRef.componentInstance.role = this.profile?.role;
      }
      this.connectDialogListeners(dialogRef, result => {
        if (result === 'closed') {
          const entity = {
            userAccountApprovePopUp: true,
          };
          this.store.dispatch(UsersActions.SavingProfile({ entity: entity, mode: 'editOwn' }));
          this.store.dispatch(UsersActions.LoadProfile());
        } else {
          this.showApproveAccountProfile = false;
        }
      });
    }
  }

  showPendingAccountModal() {
    if (!this.showPendingProfile) {
      this.showPendingProfile = true;
      let dialogRef = this.openDialogCompleteProfile(PendingValidationPopupComponent);
      this.connectDialogListeners(dialogRef, result => {
        if (result) {
          const entity = {
            userAccountPendingPopUp: true,
          };
          this.store.dispatch(UsersActions.SavingProfile({ entity: entity, mode: 'editOwn' }));
          this.store.dispatch(UsersActions.LoadProfile());
        } else {
          this.showPendingProfile = false;
        }
      });
    }
  }

  /**
   * FIN-1708 · wait for the profile the submit just reloaded, then open the popup once.
   *
   * ⚠ The store selector replays the CURRENT profile synchronously on subscribe — the
   * pre-submit one, whose verdict is still false. `take(1)` on that emission fires the
   * check against stale data and the popup never appears; a spec that seeds the store
   * with the reloaded profile passes anyway. Waiting for a document that is not the one
   * held before the dispatch is what makes this fire on the reload, once.
   *
   * Scoped to the submit deliberately (D70): there is no global subscription, so the
   * popup cannot appear on a later page load — which is also why it needs no `isBlocked`
   * or "have they signed" guard.
   */
  private openPreApprovedDepositPopupOnReload(): void {
    const profileBeforeReload = this.profile;

    this.store
      .select(UsersSelectors.profile())
      .pipe(
        filter(profile => !!profile && profile !== profileBeforeReload),
        take(1),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(profile => {
        if (this.preApprovalPopup.isPopupDue(profile)) {
          this.showPreApprovedDepositModal();
        }
      });
  }

  showPreApprovedDepositModal() {
    if (this.showPreApprovedDepositPopup) {
      return;
    }
    this.showPreApprovedDepositPopup = true;

    const dialogRef = this.openDialogCompleteProfile(
      PreApprovedDepositPopupComponent
    ) as MatDialogRef<PreApprovedDepositPopupComponent>;

    // FIN-1711 · the tier's tope, from the same profile the popup's trigger just read.
    if (dialogRef.componentInstance) {
      dialogRef.componentInstance.depositAllowance = this.profile?.depositAllowance;
    }

    this.connectDialogListeners(dialogRef, result => {
      // ⚠ Every exit marks it seen — the CTA, *Firmar ahora*, *Lo haré después*, the X,
      // and a backdrop click. `showApprovedAccountModal` above writes only on a truthy
      // result; here AC5 is "shown only once" and this flag is the only thing standing
      // between that and the popup returning on the next submit.
      this.markPreApprovedPopupSeen();

      if (result?.deposit) {
        this.goToDepositFunnel();
      } else if (result?.sign) {
        this.openSignatureFromPopup();
      }
      // `close` — and a backdrop dismissal — navigate nowhere: they stay on Oportunidades.
    });
  }

  private markPreApprovedPopupSeen(): void {
    this.store.dispatch(
      UsersActions.SavingProfile({
        entity: { userPreApprovedPopUp: true },
        mode: 'editOwn',
      })
    );
    this.store.dispatch(UsersActions.LoadProfile());
  }

  /**
   * AC3 · the cuenta bancaria first, unless they already have one.
   *
   * ⚠ `hasBanckAccount` is misspelled identically on both sides of the wire. Correcting
   * it here alone reads the wrong property and sends everyone the long way round.
   */
  private goToDepositFunnel(): void {
    if (this.profile?.hasBanckAccount) {
      this.router.navigateByUrl(DEPOSIT_ROUTE);
      return;
    }

    this.router.navigate([BANK_ACCOUNT_CREATE_ROUTE], {
      queryParams: { returnUrl: DEPOSIT_ROUTE },
    });
  }

  /**
   * *Firmar ahora*, and *Firmar mi contrato* on the 2nd and 3rd banners · the one route
   * into Keynua for a pre-approved inversionista.
   *
   * ⚠ FIN-1710 (D88, D115) · the token is minted here, on the click, and no longer at
   * submit: `laft-declarations/request-signature` builds the declaración jurada and the
   * contract, sends them and answers with the URL. The case is idempotent, so pressing the
   * button twice — or pressing it from either banner — returns the same signature request
   * rather than opening a second one.
   *
   * ⚠ `pendingKeynuaUrl` survives as the fallback for the population whose submit still
   * mints: flag off, and the investor who is not pre-approved.
   */
  private openSignatureFromPopup(): void {
    this.spinner.show();

    this.laftService.requestSignature().subscribe({
      next: response => {
        this.spinner.hide();

        if (response?.keynuaUrl) {
          this.openKeynuaModal(response.keynuaUrl);
          return;
        }

        this.openPendingKeynuaUrl();
      },
      error: err => {
        console.error('Error requesting the laft signature:', err);
        this.spinner.hide();
        this.openPendingKeynuaUrl();
      },
    });
  }

  private openPendingKeynuaUrl(): void {
    if (this.pendingKeynuaUrl) {
      this.openKeynuaModal(this.pendingKeynuaUrl);
    }
  }

  get isLaftStatusBannerDue(): boolean {
    return this.laftStatusBanner.isBannerDue(this.profile, this.laftData);
  }

  get laftStatusBannerState(): LaftStatusBannerState {
    return this.laftStatusBanner.resolve(this.profile, this.laftData);
  }

  get laftStatusBannerColumn(): LaftBannerColumn | null {
    return this.laftStatusBanner.columnFor(this.profile, this.laftData);
  }

  get laftDeclarationFacts(): any {
    return this.laftStatusBanner.effectiveDeclaration(this.profile, this.laftData);
  }

  get laftStatusBannerCopy(): LaftStatusBannerCopy {
    return resolveLaftStatusBannerCopy(
      this.laftStatusBannerState,
      this.profile,
      this.laftStatusBanner.isLaftValidationApproved(this.profile, this.laftDeclarationFacts),
      this.laftStatusBannerColumn,
      this.laftDeclarationFacts?.keynuaSignedContract === true,
    );
  }

  get isLaftBannerPathInvestor(): boolean {
    return this.laftStatusBanner.isOnLaftBannerPath(this.profile, this.laftData);
  }

  onLaftStatusBannerAction(): void {
    this.runLaftStatusBannerAction(this.laftStatusBanner.actionFor(this.laftStatusBannerState));
  }

  onLaftStatusBannerSecondaryAction(): void {
    this.runLaftStatusBannerAction(
      this.laftStatusBanner.secondaryActionFor(this.laftStatusBannerState),
    );
  }

  private runLaftStatusBannerAction(action: LaftStatusBannerAction): void {
    if (action === 'deposit') {
      this.goToDepositFunnel();
      return;
    }

    if (action !== 'sign') {
      return;
    }

    // This column's Keynua token was already minted by the investor's own submit; only
    // the pre-approved one has to ask the server for one first.
    if (this.laftStatusBannerColumn === 'noPreApproval') {
      this.openSignatureFromExistingContract();
      return;
    }

    this.openSignatureFromPopup();
  }

  private openSignatureFromExistingContract(): void {
    const keynuaToken = this.laftDeclarationFacts?.keynuaToken;

    // The column is admitted on `keynuaId`, a different field, so the token can be absent.
    // `requestSignature` is idempotent and answers with the existing contract's URL.
    if (!keynuaToken) {
      this.openSignatureFromPopup();
      return;
    }

    this.openKeynuaModal(`${environment.signingKeynuaUrl}?token=${keynuaToken}`);
  }

  onLaftStatusBannerDismiss(): void {
    this.store.dispatch(
      UsersActions.SavingProfile({
        entity: { preApprovalBannerClosed: true },
        mode: 'editOwn',
      })
    );
    this.store.dispatch(UsersActions.LoadProfile());
  }

  connectDialogListeners(dialogRef, callback) {
    dialogRef.afterClosed().subscribe(callback);
  }

  async openLaftModal() {
    if (!this.laftModalDialog) {
      this.clearPendingContractsSignatureWatch();
      this.laftService.getData().subscribe(data => {
        this.laftModalDialog = this.dialog.open(LaftModalComponent, {
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          maxHeight: '100vh',
          id: 'laft-dialog',
          data: {
            user: this.profile,
            LAFTData: data.LAFTData,
          },
        });

        this.laftModalDialog.componentInstance.formSubmitted.subscribe((formData: any) => {
          setTimeout(() => {
            this.spinner.show();
            this.laftService.createLaftDeclaration(formData).subscribe({
              next: response => {
                this.spinner.hide();

                // FIN-1710 §2.11 · branch on the verdict, never on the URL. A pre-approved
                // investor's submit no longer mints a Keynua token (D97), so `keynuaUrl` is
                // absent for them — and the guard below used to wrap the reload, the popup
                // *and* the modal close, so the whole path died silently at the `if`: no
                // reload, no popup, and the LAFT form left on screen.
                if (response?.isPreApproved === true) {
                  this.store.dispatch(UsersActions.LoadProfile());
                  this.openPreApprovedDepositPopupOnReload();
                  // The LAFT modal's own afterClosed navigates to /opportunities.
                  this.laftModalDialog?.close();
                  return;
                }

                if (response && response.keynuaUrl) {
                  this.store.dispatch(UsersActions.LoadProfile());

                  // FIN-1708 · behind `laft-pn-v2`, submitting no longer forces the
                  // signature: the investor PN lands on Oportunidades and the popup
                  // offers the deposit, with *Firmar ahora* as the way into Keynua.
                  // Flag off — and for persona jurídica either way — this is unchanged.
                  //
                  // ⚠ FIN-1710 · the verdict comes off the response, not the profile: that
                  // document is pre-submit and its verdict is stale. Reaching here with a
                  // URL means the investor is *not* pre-approved, so they go straight to the
                  // widget as they do today (§2.13).
                  if (this.preApprovalPopup.shouldDeferSignature(this.profile, response)) {
                    this.pendingKeynuaUrl = response.keynuaUrl;
                    this.openPreApprovedDepositPopupOnReload();
                    // The LAFT modal's own afterClosed navigates to /opportunities.
                    this.laftModalDialog?.close();
                  } else {
                    this.openKeynuaModal(response.keynuaUrl);
                  }
                }
              },
              error: err => {
                console.error('Error creating Laft declaration:', err);
                this.spinner.hide();
                this.showCompleteProfile = false;
              },
            });
          }, 100);
        });

        this.laftModalDialog.componentInstance.saveEvent.subscribe((formData: any) => {
          this.spinner.show();
          this.laftService.save(formData).subscribe({
            next: () => {
              this.spinner.hide();
              this.store.dispatch(UsersActions.LoadProfile());
            },
            error: err => {
              console.error('Error creating Laft declaration:', err);
              this.spinner.hide();
            },
          });
        });

        this.laftModalDialog.afterClosed().subscribe(() => {
          this.laftModalDialog = null;
          console.log('Laft modal was closed');
          this.router.navigateByUrl('/opportunities', { replaceUrl: true });
        });
      });
    }
  }

  async openLaftLegalModal(initialStep?: number) {
    if (!this.laftLegalModalDialog) {
      this.clearPendingContractsSignatureWatch();
      this.laftService.getData().subscribe(data => {
        this.laftData = data.LAFTData;
        this.laftLegalModalDialog = this.dialog.open(LaftLegalModalComponent, {
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          maxHeight: '100vh',
          id: 'laft-dialog',
          data: {
            user: this.profile,
            laftData: this.laftData,
            initialStep: initialStep,
          },
        });

        this.laftLegalModalDialog.componentInstance.formSubmitted.subscribe((formData: any) => {
          const payload = formData?.payload ?? formData;
          const isPendingPepFlowSubmit = !!formData?.isPendingPepFlowSubmit;
          setTimeout(() => {
            this.spinner.show();
            this.laftService.createLegalLaftDeclaration(payload).subscribe({
              next: response => {
                this.spinner.hide();
                if (isPendingPepFlowSubmit) {
                  this.laftWaitingForRealtimeAfterPepSubmit = true;
                  if (this.laftPepSubmitRefreshTimeout) clearTimeout(this.laftPepSubmitRefreshTimeout);
                  this.laftPepSubmitRefreshTimeout = setTimeout(() => {
                    this.laftWaitingForRealtimeAfterPepSubmit = false;
                    this.laftPepSubmitRefreshTimeout = null;
                    this.getLaftData();
                    this.store.dispatch(UsersActions.LoadProfile());
                  }, 8000);
                } else {
                  this.store.dispatch(UsersActions.LoadProfile());
                }
              },
              error: err => {
                console.error('Error creating Laft declaration:', err);
                this.spinner.hide();
              },
            });
          }, 500);
        });

        this.laftLegalModalDialog.componentInstance.saveEvent.subscribe((formData: any) => {
          this.spinner.show();
          this.laftService.saveLegalLaftDeclaration(formData).subscribe({
            next: () => {
              this.spinner.hide();
              this.store.dispatch(UsersActions.LoadProfile());
            },
            error: err => {
              console.error('Error saving Laft declaration:', err);
              this.spinner.hide();
            },
          });
        });

        this.laftLegalModalDialog.afterClosed().subscribe(() => {
          this.laftLegalModalDialog = null;
          console.log('Laft modal was closed');
          this.router.navigateByUrl('/opportunities', { replaceUrl: true });
        });
      });
    }
  }

  private saveLaftByStep(formData: any): Observable<any> {
    const laftId = this.laftData?.id;

    const step = formData.saveAndExit ? +formData.step : +formData.step - 1;
    const body = { ...formData };

    if (step === 1) return this.laftService.updatePersonalData(laftId, body);
    if (step === 2) return this.laftService.updateCompanyBeneficiary(laftId, body);
    if (step === 3) {
      const isPendingPepFlow = !!formData.isPendingPepFlow;
      if (isPendingPepFlow) {
        delete body.isPendingPepFlow;
        delete body.pendingPepFlowMetadata;
        return this.laftService.updatePendingPepData(laftId, body);
      }
      return this.laftService.updatePepData(laftId, body);
    }
    if (step === 4) return this.laftService.updateInvestigationData(laftId, body);

    return this.laftService.saveLegalLaftDeclaration(formData);
  }

  openKeynuaModal(keynuaUrl: string) {
    this.clearPendingContractsSignatureWatch();
    // Close the LAFT modal if it's open (it stays in the background)
    if (this.laftModalDialog) {
      this.laftModalDialog.close();
      this.laftModalDialog = null;
    }

    // New implementation: Opens Keynua Widget modal (user stays in Finsmart)
    this.laftKeynuaWidgetDialog = this.dialog.open(LaftKeynuaWidgetModalComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        user: this.profile,
        keynuaUrl: keynuaUrl,
      },
    });

    // When widget modal closes, reload profile and LAFT data to update banner
    this.laftKeynuaWidgetDialog.afterClosed().subscribe(result => {
      console.log('Keynua widget modal closed:', result);
      this.laftKeynuaWidgetDialog = null;

      // Always reload profile and LAFT data when modal closes
      this.store.dispatch(UsersActions.LoadProfile());
      this.getLaftData();

      // Navigate to opportunities
      this.router.navigateByUrl('/opportunities', { replaceUrl: true });
    });

    // Old implementation: QR code modal (kept for reference)
    // this.laftKeynuaDialog = this.dialog.open(LaftKeynuaQrModalComponent, {
    //   width: '100vw',
    //   height: '100vh',
    //   maxWidth: '100vw',
    //   maxHeight: '100vh',
    //   data: {
    //     user: this.profile,
    //     keynuaUrl: keynuaUrl,
    //   },
    // });
  }

  /**
   * QR full-screen para representantes legales (contratos empresa / RUC).
   * Prioriza tokens en contratos (flujo firma pendiente / Keynua multi-sign); si no hay, usa LAFT
   * `airtableRepresentativeData` como antes (banner / DJ).
   */
  openCompanyKeynuaModal() {
    if (this.laftCompanyKeynuaDialog) {
      return;
    }
    const laft$ =
      this.profile?.role === Roles.CLIENT
        ? this.laftService.getClientData()
        : this.laftService.getData();

    forkJoin({
      laft: laft$.pipe(take(1), catchError(() => of({ LAFTData: null }))),
      contracts: this.contractService.getMyContracts().pipe(take(1), catchError(() => of([]))),
    }).subscribe(({ laft, contracts }) => {
      this.laftData = laft?.LAFTData;
      const list = Array.isArray(contracts) ? contracts : [];
      const fromContracts = this.buildContractLegalRepresentatives(list);
      if (fromContracts.length > 0) {
        this.openCompanyKeynuaModalWithRepresentatives(fromContracts);
        return;
      }
      this.openCompanyKeynuaModalWithRepresentatives(
        this.buildLegalRepresentativesFromLaftAirtable(this.laftData),
      );
    });
  }

  /** Tokens en `airtableRepresentativeData` (comportamiento histórico antes de leer solo contratos). */
  private buildLegalRepresentativesFromLaftAirtable(laftData: any): { fullName: string; keynuaUrl: string }[] {
    const legalRepresentatives: { fullName: string; keynuaUrl: string }[] = [];
    if (laftData?.airtableRepresentativeData && Array.isArray(laftData.airtableRepresentativeData)) {
      laftData.airtableRepresentativeData.forEach((rep: any) => {
        if (rep.token) {
          const fullName = `${rep.names || ''} ${rep.lastNames || ''}`.trim();
          legalRepresentatives.push({
            fullName: fullName || 'Representante Legal',
            keynuaUrl: `${environment.signingKeynuaUrl}?token=${rep.token}`,
          });
        }
      });
    }
    return legalRepresentatives;
  }

  /** URLs de firma a partir de `signers[].token` en cada contrato (documento). */
  private buildContractLegalRepresentatives(contracts: any[]): { fullName: string; keynuaUrl: string }[] {
    const out: { fullName: string; keynuaUrl: string }[] = [];
    const seen = new Set<string>();
    for (const c of contracts ?? []) {
      if (!Array.isArray(c?.signers)) {
        continue;
      }
      for (const s of c.signers) {
        if (!s?.token || seen.has(s.token)) {
          continue;
        }
        seen.add(s.token);
        out.push({
          fullName: (s.name || '').trim() || 'Representante Legal',
          keynuaUrl: `${environment.signingKeynuaUrl}?token=${s.token}`,
        });
      }
    }
    return out;
  }

  private contractsHaveSignerTokens(contracts: any[] | null | undefined): boolean {
    return this.buildContractLegalRepresentatives(contracts ?? []).length > 0;
  }

  private openCompanyKeynuaModalWithRepresentatives(
    legalRepresentatives: { fullName: string; keynuaUrl: string }[],
  ): void {
    if (legalRepresentatives.length === 0 || this.laftCompanyKeynuaDialog) {
      return;
    }
    this.laftCompanyKeynuaDialog = this.dialog.open(LaftCompanyKeynuaQrComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      id: 'laft-company-keynua-dialog',
      data: {
        user: this.profile,
        legalRepresentatives,
      },
    });

    this.laftCompanyKeynuaDialog.componentInstance.explorePlatformEvent.subscribe(() => {
      this.laftCompanyKeynuaDialog = null;
    });

    this.laftCompanyKeynuaDialog.afterClosed().subscribe(() => {
      this.laftCompanyKeynuaDialog = null;
    });
  }

  private clearPendingContractsSignatureWatch(): void {
    if (this.pendingContractsSignatureSocketTimeout != null) {
      clearTimeout(this.pendingContractsSignatureSocketTimeout);
      this.pendingContractsSignatureSocketTimeout = null;
    }
    this.pendingContractsSignatureAwaitingSocket = false;
  }

  private isLaftDeclarationSigningFlowOpen(): boolean {
    return !!(
      this.laftLegalModalDialog ||
      this.laftModalDialog ||
      this.laftKeynuaWidgetDialog
    );
  }

  private onPendingContractsSignatureReadyFromSocket(): void {
    this.clearPendingContractsSignatureWatch();
    this.spinner.hide();
    this.openCompanyKeynuaModal();
  }

  private applyContractRevalidationRequested(): void {
    this.spinner.hide();
    this.laftStatus = LaftStatus.InReview;
    this.cdr.markForCheck();
  }

  private startPendingContractsSignatureAndOpenQr(): void {
    this.clearPendingContractsSignatureWatch();

    this.laftService.requestPendingContractsSignature().subscribe({
      next: res => {
        if (res?.revalidationRequested) {
          this.applyContractRevalidationRequested();
          return;
        }

        this.pendingContractsSignatureAwaitingSocket = true;
        this.pendingContractsSignatureSocketTimeout = setTimeout(() => {
          this.pendingContractsSignatureSocketTimeout = null;
          if (!this.pendingContractsSignatureAwaitingSocket) {
            return;
          }
          this.clearPendingContractsSignatureWatch();
          this.spinner.hide();
          showToast(
            this.toaster,
            'La preparación de la firma está tardando demasiado. Intenta de nuevo en unos minutos.',
            false,
            true,
          );
        }, 120000);
      },
      error: err => {
        this.clearPendingContractsSignatureWatch();
        this.spinner.hide();
        const raw = err?.error?.message;
        const msg = Array.isArray(raw) ? raw[0] : raw ?? 'No se pudo iniciar la firma de contratos';
        showToast(this.toaster, String(msg), false, true);
      },
    });
  }

  /** Solo factoring/confirming sin DJ → Keynua contratos; si no, modal LAFT legal. */
  private shouldOpenContractsSignatureAfterSelection(selectedDocuments: string[]): boolean {
    if (!Array.isArray(selectedDocuments) || selectedDocuments.length === 0) {
      return false;
    }
    if (selectedDocuments.includes(SignDocumentTypes.DECLARACION_JURADA)) {
      return false;
    }
    return (
      selectedDocuments.includes(SignDocumentTypes.FACTORING) ||
      selectedDocuments.includes(SignDocumentTypes.CONFIRMING)
    );
  }

  private openChooseDocumentsSelectionDialog(bannerData: any): void {
    const dialog = this.dialog.open(ChooseDocumentsSignPopupComponent, {
      maxWidth: '600px',
      id: 'choose-documents-sign-popup-dialog',
      panelClass: 'choose-documents-sign-popup-dialog',
      data: { laftStatus: bannerData.laftStatus },
    });

    dialog.componentInstance.selectOptionEvent
      .pipe(take(1), takeUntil(this.ngUnsubscribe))
      .subscribe((selectedDocuments: string[]) => {
        setTimeout(() => {
          this.spinner.show();
          this.onboardingService
            .selectSignDocuments(this.profile?._id, selectedDocuments)
            .subscribe({
              next: response => {
                dialog.close();
                this.laftStatus =
                  response?.milestones?.laft?.status || LaftStatus.Pending;

                if (this.shouldOpenContractsSignatureAfterSelection(selectedDocuments)) {
                  this.startPendingContractsSignatureAndOpenQr();
                } else {
                  this.spinner.hide();
                  this.openLaftLegalModalForClient();
                }
              },
              error: err => {
                console.error('Error creating Laft declaration:', err);
                this.spinner.hide();
                dialog.close();
                showToast(
                  this.toaster,
                  'No se pudo registrar tu selección. Vuelve a intentarlo.',
                  false,
                  true,
                );
              },
            });
        }, 100);
      });
  }

  openClientContractDialog() {
    if (!this.clientContractDialog) {
      this.clientContractDialog = this.dialog.open(ClientContractDialogComponent, {
        width: '376px',
        // height: '416px',
        // maxWidth: '90vw',
        disableClose: true,
        panelClass: 'client-contract-dialog',
        id: 'client-contract-dialog',
      });

      this.clientContractDialog.afterClosed().subscribe(() => {
        this.clientContractDialog = null;
        console.log('Client contract dialog was closed');
      });
    }
  }

  openNewContractPopup() {
    if (!this.newContractPopupRef && this.featureFlagService.isCostoSinIgvPlusOneEnabled()) {
      this.newContractPopupRef = this.dialog.open(NewContractPopupComponent, {
        width: '376px',
        disableClose: true,
        panelClass: 'new-contract-popup',
        backdropClass: 'new-contract-popup-backdrop',
        id: 'new-contract-popup',
      });

      this.newContractPopupRef.afterClosed().subscribe(() => {
        this.newContractPopupRef = null;
      });
    }
  }

  openChooseDocumentsSignPopup(data: any): void {
    if (data?.laftStatus === LaftStatus.InProgress) {
      this.openLaftLegalModalForClient();
      return;
    }
    if (data?.laftStatus === LaftStatus.PepRequested) {
      this.openLaftLegalModalForClient(3);
      return;
    }
    if (data?.laftStatus === LaftStatus.SignatureRequested || data?.laftStatus === LaftStatus.Error) {
      this.openCompanyKeynuaModal();
      return;
    }

    if (data?.laftStatus === LaftStatus.Completed) {
      this.spinner.show();
      this.contractService
        .getMyContracts()
        .pipe(take(1), takeUntil(this.ngUnsubscribe), catchError(() => of([])))
        .subscribe({
          next: contracts => {
            this.spinner.hide();
            const list = Array.isArray(contracts) ? contracts : [];
            if (this.contractsHaveSignerTokens(list)) {
              this.openCompanyKeynuaModalWithRepresentatives(
                this.buildContractLegalRepresentatives(list),
              );
              return;
            }
            this.openChooseDocumentsSelectionDialog(data);
          },
          error: () => {
            this.spinner.hide();
            this.openChooseDocumentsSelectionDialog(data);
          },
        });
      return;
    }

    this.openChooseDocumentsSelectionDialog(data);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.profile = '';
    this.clearClientOnboardingAwaitingInReview();

    this.featureFlagService.destroy();
    console.log('[App] LaunchDarkly connection closed');
  }

  getCurrentToggle() {
    this.toogleCurrency = localStorage.getItem('toggle_currency') || 'PEN';
    this.toogleCurrencyInvestment = localStorage.getItem('toggle_currency_investment') || 'PEN';
    this.toogleCurrencyTransactions = localStorage.getItem('toggle_transaction_currency') || 'PEN';
  }

  setCurrentStep() {
    this.stepsSetupBarGeneral = this.stepsSetupBar;
    if (this.profile.setupbarClosed === false) {
      this.hideByDefault = true;
      if (this.profile.role === 'client' && this.profile.hasBanckAccount === false) {
        this.currenStepSetupBar = 2;
        this.displayCloseButton = false;
      } else if (
        this.profile.role === 'client' &&
        this.profile.hasBanckAccount === true &&
        this.profile.hasInvoice === false
      ) {
        this.currenStepSetupBar = 3;
        this.displayCloseButton = false;
      } else if (
        this.profile.role === 'client' &&
        this.profile.hasBanckAccount === true &&
        this.profile.hasInvoice === true &&
        this.profile.hasSignContract === false
      ) {
        this.currenStepSetupBar = 4;
        this.displayCloseButton = false;
      } else if (
        this.profile.role === 'client' &&
        this.profile.hasBanckAccount === true &&
        this.profile.hasInvoice === true &&
        this.profile.hasSignContract === true
      ) {
        this.currenStepSetupBar = 5;
        this.displayCloseButton = true;
        this.titleSetupBar = '¡Pasos completados!';
        //this.sendLastSetupStep()
      }
    } else {
      this.hideByDefault = false;
    }
  }

  setCurrentStepInvestor() {
    this.stepsSetupBarGeneral = this.stepsSetupBarInvestor;
    if (this.profile.setupbarClosed === false) {
      this.hideByDefault = true;
      if (this.profile.role === 'investor' && this.profile.hasBanckAccount === false) {
        this.currenStepSetupBar = 2;
        this.displayCloseButton = false;
      } else if (
        this.profile.role === 'investor' &&
        this.profile.hasBanckAccount === true &&
        this.profile.hasDeposit === false
      ) {
        this.currenStepSetupBar = 3;
        this.displayCloseButton = false;
      } else if (
        this.profile.role === 'investor' &&
        this.profile.hasBanckAccount === true &&
        this.profile.hasDeposit === true &&
        this.profile.hasInvestment === false
      ) {
        this.currenStepSetupBar = 4;
        this.displayCloseButton = false;
      } else if (
        this.profile.role === 'investor' &&
        this.profile.hasBanckAccount === true &&
        this.profile.hasDeposit === true &&
        this.profile.hasInvestment === true
      ) {
        this.currenStepSetupBar = 5;
        this.displayCloseButton = true;
        this.titleSetupBar = '¡Pasos completados!';
      }
    } else {
      this.hideByDefault = false;
    }
  }

  sendEvent() {
    let event = {
      event: '[Platform][Modal][Legal]',
      _inputValue: this.profile._id,
    };
    this.gtmService.newEvent(event);

    this.sendEventModalView();
  }

  sendEventModalView() {
    this.pageTitle = 'General';
    this.sectionTitle = 'Account Modal';
    this.sendEventPageView();
  }

  closeSetup() {
    const entity = {
      setupbarClosed: true,
    };
    this.sendEventSetup();

    this.store.dispatch(UsersActions.SavingProfile({ entity: entity, mode: 'editOwn' }));
    this.store.dispatch(UsersActions.LoadProfile());
    this.store.dispatch(AuthActions.ShowPopUp());
  }

  sendEventSetup() {
    let event = {
      event: '[Platform][Setup][Bar]',
      _inputCategory: `General / Setup Bar`,
      _inputName: `Exit Setup Bar In Setup Bar`,
      _userId: this.profile._id,
    };
    this.gtmService.newEvent(event);
  }

  sendEventPageView() {
    if (this.resourceURI !== '/') {
      const baseUrl = environment.clientUrl;
      const eventName = 'page_view';
      const eventData: any = {
        page_url: baseUrl + this.resourceURI,
        page_title: this.pageTitle,
        section_step: this.sectionTitle,
      };
      if (this.activeTab) eventData.active_tab = this.activeTab;
      if (this.pageCurrency) eventData.page_currency = this.pageCurrency;

      if (this.profile?.role === Roles.INVESTOR) {
        this.gaService.sendEvent(eventName, eventData);
        this.mixPanelService.newEvent(eventName, eventData);
        // this.sendEventScroll();
      } else if (this.profile?.role === Roles.CLIENT) {
        this.gaService.sendEvent(eventName, eventData);
        if (eventData?.page_title !== 'Invoices' && eventData?.page_title !== 'Profile settings') {
          this.mixPanelService.newEvent(eventName, eventData);
        }
      } else if (this.profile?.role === undefined) {
        this.mixPanelService.newEvent(eventName, eventData);
      }
    }
  }

  sendEventScroll() {
    if (this.resourceURI !== '/') {
      const baseUrl = environment.clientUrl;
      const eventName = 'page_scroll';
      const eventData: any = {
        page_url: baseUrl + this.resourceURI,
        page_title: this.pageTitle,
        section_step: this.sectionTitle,
        page_scroll: this.pageScroll,
      };

      if (this.activeTab) eventData.active_tab = this.activeTab;
      if (this.pageCurrency) eventData.page_currency = this.pageCurrency;
      if (this.profile?.role === Roles.CLIENT || this.profile?.role === Roles.INVESTOR) {
        this.gaService.sendEvent(eventName, eventData);
        this.mixPanelService.newEvent(eventName, eventData);
      }
    }
  }

  setPageTitle() {
    switch (this.resourceURI) {
      case '/my-clients':
        this.pageTitle = 'My clients';
        this.sectionTitle = 'Overview';
        this.resetTab();

        break;

      case '/invoices':
        this.pageTitle = 'Invoices';
        this.sectionTitle = 'Overview';
        this.resetTab();

        break;

      case '/my-suppliers':
        this.pageTitle = 'My suppliers';
        this.sectionTitle = 'Overview';
        this.resetTab();

        break;

      case '/bank-accounts':
        this.pageTitle = 'Bank accounts';
        this.sectionTitle = 'Overview';
        this.resetTab();

        break;

      case '/profile-settings':
        this.pageTitle = 'Profile settings';
        this.sectionTitle = 'Overview';
        this.resetTab();

        break;

      case '/opportunities':
        this.pageTitle = 'Opportunities';
        this.sectionTitle = 'Overview';
        this.pageCurrency = this.toogleCurrency.toUpperCase() || 'PEN';
        this.activeTab = 'Publicadas';
        //console.log( this.pageCurrency, this.activeTab, this.toogleCurrency )
        break;

      case '/my-investments':
        this.pageTitle = 'My Investments';
        this.sectionTitle = 'Overview ';
        this.pageCurrency = this.toogleCurrencyInvestment.toUpperCase() || 'PEN';
        this.activeTab = 'En curso';
        break;

      case '/financial-transactions':
        this.pageTitle = 'Financial Transactions';
        this.sectionTitle = 'Overview';
        this.pageCurrency = this.toogleCurrencyTransactions.toUpperCase() || 'PEN';
        this.activeTab = 'Depósitos';
        break;

      case '/financial-transactions/deposit':
        this.pageTitle = 'Financial transaction';
        this.sectionTitle = 'Deposit step 1';
        this.resetTab();

        break;

      case '/financial-transactions/withdraw':
        this.pageTitle = 'Financial transaction';
        this.sectionTitle = 'Withdraw step 1';
        this.resetTab();

        break;

      case '/financial-transactions/donate':
        this.pageTitle = 'Financial transaction';
        this.sectionTitle = 'Donate step 1';
        this.resetTab();

        break;

      case '/invoices/create':
        this.pageTitle = 'Invoice';
        this.sectionTitle = 'New step 1';
        this.resetTab();

        break;

      case '/invoices/create':
        this.pageTitle = 'Profile settings';
        this.sectionTitle = 'Password Change Step 1';
        this.resetTab();

        break;

      case '/signup':
        this.pageTitle = 'Signup';
        this.sectionTitle = 'Step 1';
        this.resetTab();

        break;

      case '/auth/forgot-password':
        this.pageTitle = 'Forgot Password';
        this.sectionTitle = 'Step 1';
        this.resetTab();

        break;

      default:
        this.pageTitle = 'General';
        this.sectionTitle = 'Broken Link';
        this.resetTab();

        break;
    }
  }

  calculatePercentageScroll() {
    this.scrollTo = document.documentElement.scrollTop;
    this.bodyScrollTo = document.body.scrollTop;
    this.scrollHeight = document.documentElement.scrollHeight;
    this.clientHeight = document.documentElement.clientHeight;
    let scroll = Math.max(
      Math.trunc(((this.scrollTo + this.bodyScrollTo) / (this.scrollHeight - this.clientHeight)) * 100)
    );
    return scroll;
  }

  resetRange() {
    this.scrollTo = 0;
    this.lastScroll = 0;
    this.pageScroll = 0;
    this.range_25 = false;
    this.range_50 = false;
    this.range_75 = false;
    this.range_100 = false;
  }

  getTitlePage() {
    let splitUrl = this.resourceURI.split('/');
    let splitUrlToken = this.resourceURI.split('?');
    if (splitUrlToken[0] === '/auth') {
      this.route.queryParams.subscribe(params => {
        if (params.token) {
          this.pageTitle = 'Signup';
          this.sectionTitle = 'Step 5';
          this.resetTab();
        } else {
          this.pageTitle = 'Login';
          this.sectionTitle = 'Login';
          this.resetTab();
        }
      });
    } else if (splitUrlToken[0] === '/auth/forgot-password') {
      this.pageTitle = 'Forgot Password';
      this.sectionTitle = 'Step 1';
      this.resetTab();
    } else if (splitUrl.length === 2) {
      this.setPageTitle();
    } else {
      if (splitUrl[1] === 'my-clients' && splitUrl[2] === 'create') {
        this.pageTitle = 'My clients';
        this.sectionTitle = 'New step 1';
        this.resetTab();
      } else if (splitUrl[1] === 'my-clients' && splitUrl[2] !== 'create') {
        this.pageTitle = 'My clients';
        this.sectionTitle = 'Detail';
        this.resetTab();
      }
      if (splitUrl[1] === 'my-suppliers' && splitUrl[2] === 'create') {
        this.pageTitle = 'My suppliers';
        this.sectionTitle = 'New step 1';
        this.resetTab();
      } else if (splitUrl[1] === 'my-suppliers' && splitUrl[2] !== 'create') {
        this.pageTitle = 'My suppliers';
        this.sectionTitle = 'Detail';
        this.resetTab();
      }
      if (splitUrl[1] === 'invoices' && splitUrl[2] === 'create') {
        this.pageTitle = 'Invoices';
        this.sectionTitle = 'New step 1';
        this.resetTab();
      } else if (splitUrl[1] === 'invoices' && splitUrl[2] !== 'create') {
        this.pageTitle = 'Invoices';
        this.sectionTitle = 'Detail';
        this.resetTab();
      }
      if (splitUrl[1] === 'bank-accounts') {
        this.pageTitle = 'Bank Accounts';
        this.sectionTitle = 'New Step 1';
        this.resetTab();
      }
      if (splitUrl[1] === 'financial-transactions' && splitUrl[2] === 'deposit') {
        this.pageTitle = 'Financial Transactions';
        this.sectionTitle = 'Deposit Step 1';
      } else if (splitUrl[1] === 'financial-transactions' && splitUrl[2] === 'withdraw') {
        this.pageTitle = 'Financial Transactions';
        this.sectionTitle = 'Withdraw Step 1';
      } else if (splitUrl[1] === 'financial-transactions' && splitUrl[2] === 'donate') {
        this.pageTitle = 'Financial Transactions';
        this.sectionTitle = 'Donate Step 1';
      }

      if (splitUrl[1] === 'profile-settings' && splitUrl[2] === 'change-password') {
        this.pageTitle = 'Profile Settings';
        this.sectionTitle = 'Password Change Step 1';
        this.resetTab();
      }
    }
  }

  resetTab() {
    this.pageCurrency = null;
    this.activeTab = null;
  }

  trackScroll(scroll) {
    if (this.scrollTo > this.lastScroll) {
      if (scroll > 25 && scroll < 50) {
        this.pageScroll = 25;
        if (!this.range_25) {
          this.sendEventScroll();
        }
        this.range_25 = true;
        //this.sendEventPageView()
      } else if (scroll > 50 && scroll < 75) {
        this.pageScroll = 50;
        if (!this.range_50) {
          this.sendEventScroll();
        }
        this.range_50 = true;
      } else if (scroll > 75 && scroll < 100) {
        this.pageScroll = 75;
        if (!this.range_75) {
          this.sendEventScroll();
        }
        this.range_75 = true;
      } else if (scroll === 100) {
        this.pageScroll = 100;
        if (!this.range_100) {
          this.sendEventScroll();
        }
        this.range_100 = true;
      }
    }
  }
  defaultLauncher() {
    if (this.isMobile) {
      this.windowScrollService.setDefaultLauncher(false);
    }
  }

  get shouldShowLaftBanner(): boolean {
    return !!(
      this.profile &&
      this.profile.role === this.roles.INVESTOR &&
      this.profile.status !== this.userStatus.Disapproved &&
      (this.profile.idType === IdType.RUC
        ? this.featureFlagService.isLAFTJuridicaEnabled()
        : this.featureFlagService.isLAFTEnabled()) &&
      (this.profile.incompleteProfile ||
        (this.profile.incompleteProfile === false &&
          (this.profile.status === this.userStatus.Pending ||
            this.profile.status === this.userStatus['Email Verified'] ||
            this.profile.status === this.userStatus['In Review'])))
    );
  }

  get laftBannerStatus():
    | 'incomplete'
    | 'pending'
    | 'error'
    | 'inReview'
    | 'unsigned'
    | 'validating'
    | 'pendingPep'
    | 'postPepSubmitWaiting' {
    if (this.laftWaitingForRealtimeAfterPepSubmit) {
      return 'postPepSubmitWaiting';
    }
    if (
      (this.profile?.status === this.userStatus['Email Verified'] ||
        this.profile?.status === this.userStatus['In Review']) &&
      this.profile?.hasLaftProfileError
    ) {
      return 'error';
    }

    if (this.laftData?.pendingAdditionalPepInfo) {
      return 'pendingPep';
    }

    if (this.laftData?.keynuaId && !this.laftData?.keynuaSignedContract) {
      if (this.laftData?.keynuaWidgetSigned) {
        return 'validating';
      }
      return 'unsigned';
    }

    if (this.profile?.status === this.userStatus['In Review']) {
      return 'inReview';
    }

    if (this.profile?.incompleteProfile) {
      return 'incomplete';
    }
    return 'pending';
  }

  get laftBannerConfig() {
    return {
      incomplete: {
        title: 'Completa tu perfil para comenzar a invertir',
        description:
          'Retoma tu validación de identidad y cumplimiento LAFT para habilitar tus depósitos y seguir invirtiendo.',
        showButton: true,
        buttonText: 'Completar',
      },
      pending: {
        title: '¡Ya casi estás listo para invertir!',
        description:
          'Estamos revisando tus datos. Te enviaremos un correo en menos de 12 horas para avisarte cuando todo esté listo.',
        showButton: false,
        buttonText: '',
      },
      error: {
        title: 'Ocurrió un error al procesar tu firma',
        description: 'Asegúrate de que tu rostro y documento de identidad sean capturados correctamente.',
        showButton: true,
        buttonText: 'Subsanar error',
      },
      inReview: {
        title: 'Revisando tu información y preparando el contrato y la declaración jurada',
        description: 'Recibirás tus documentos listos para firmar en breves momentos.',
        showButton: false,
        buttonText: '',
      },
      unsigned: {
        title: 'Documentos listos para firma',
        description: 'La declaración jurada y el contrato están listos para ser firmados.',
        showButton: true,
        buttonText: 'Ir a firmar',
      },
      validating: {
        title: 'Validando la firma al Contrato y Declaración Jurada',
        description: 'Este proceso puede tomar unos segundos.',
        showButton: false,
        buttonText: '',
      },
      pendingPep: {
        title: 'Ya casi terminamos',
        description:
          'Actualizamos la información de los representantes legales y solo necesitamos confirmar si alguno es o ha sido PEP (o si tiene familiares en esa condición) para continuar con la firma.',
        showButton: true,
        buttonText: 'Responder',
      },
      postPepSubmitWaiting: {
        title: 'Hemos recibido tu información',
        description: 'Estamos preparando tu documentación para firma. En breve podrás ir a firmar.',
        showButton: false,
        buttonText: '',
      },
    }[this.laftBannerStatus];
  }

  handleLaftAction() {
    if (this.laftBannerStatus === 'incomplete') {
      this.laftService.logLaftDeclarationAction(
        LAFT_HISTORY_ACTIONS.COMPLETAR_BANNER.action,
        LAFT_HISTORY_ACTIONS.COMPLETAR_BANNER.actionDescription,
        this.laftData?._id ?? undefined
      );
    }
    const keynuaToken = this.laftData?.keynuaToken;
    const keynuaUrl = `${environment.signingKeynuaUrl}?token=${keynuaToken}`;

    if (this.laftBannerStatus === 'pendingPep') {
      this.openLaftLegalModal(3);
    } else if (this.laftBannerStatus === 'unsigned') {
      if (this.profile?.idType === IdType.RUC) {
        this.openCompanyKeynuaModal();
      } else {
        this.openKeynuaModal(keynuaUrl);
      }
    } else if (
      (this.laftBannerStatus === 'incomplete' && this.laftData?.keynuaToken) ||
      this.laftBannerStatus === 'error'
    ) {
      if (this.profile?.idType === IdType.RUC) {
        this.openCompanyKeynuaModal();
      } else {
        this.openKeynuaModal(keynuaUrl);
      }
    } else if (this.laftBannerStatus === 'incomplete' && !this.laftData?.keynuaToken) {
      if (this.profile?.idType === IdType.RUC) {
        this.openLaftLegalModal();
      } else {
        this.openLaftModal();
      }
    }
  }

  async openLaftLegalModalForClient(initialStep?: number) {
    if (this.laftLegalModalDialog) return;

    this.clearPendingContractsSignatureWatch();

    this.laftService.getClientData().subscribe(data => {
      this.laftData = data.LAFTData;
      this.laftLegalModalDialog = this.dialog.open(LaftLegalModalComponent, {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        id: 'laft-dialog',
        data: {
          user: this.profile,
          laftData: this.laftData,
          initialStep: initialStep ?? {},
        },
      });

      this.laftLegalModalDialog.componentInstance.formSubmitted.subscribe((formData: any) => {
        const payload = formData?.payload ?? formData;
        const laftId = this.laftData?.id;
        const shouldWaitForClientOnboardingRefresh =
          initialStep === 3 || this.isClientPepRequestedStatus(this.laftStatus);
        if (shouldWaitForClientOnboardingRefresh) {
          this.startClientOnboardingAwaitingInReview();
        }
        const body = {
          saveAndExit: false,
          step: '5',
          isInvestigated: payload?.isInvestigated ?? false,
          investigations: payload?.isInvestigated && Array.isArray(payload?.investigations)
            ? payload.investigations
            : [],
          acceptsContract: payload?.acceptsContract,
          acceptsCommercialUse: payload?.acceptsCommercialUse,
        };
        this.spinner.show();
        this.laftService.updateInvestigationData(laftId, body).subscribe({
          next: () => {
            if (!shouldWaitForClientOnboardingRefresh) {
              this.spinner.hide();
            }
            this.store.dispatch(UsersActions.LoadProfile());
          },
          error: err => {
            console.error('Error submitting LAFT step 4:', err);
            if (shouldWaitForClientOnboardingRefresh) {
              this.clearClientOnboardingAwaitingInReview();
            }
            this.spinner.hide();
          },
        });
      });

      this.laftLegalModalDialog.componentInstance.saveEvent.subscribe((formData: any) => {
        this.spinner.show();
        this.saveLaftByStep(formData).subscribe({
          next: () => {
            this.spinner.hide();
            this.store.dispatch(UsersActions.LoadProfile());
          },
          error: err => {
            console.error('Error saving Laft declaration:', err);
            this.spinner.hide();
          },
        });
      });

      this.laftLegalModalDialog.afterClosed().subscribe(() => {
        this.laftLegalModalDialog = null;
      });
    });
  }

  get showOnboardingBanner(): boolean {
    return !this.hideSetup
      && this.featureFlagService.isLAFTClientEnabled()
      && this.profile?.role === Roles.CLIENT
      && !this.onboardingBannerIsFullyCompleted;
  }

  get showTopBarAndSetup(): boolean {
    if (this.clientOnboardingAwaitingInReview) {
      return false;
    }
    if (this.onboardingBannerIsFullyCompleted) {
      return false;
    }
    return !this.showOnboardingBanner || !this.onboardingBannerHasData;
  }

  onOnboardingBannerHasData(hasData: boolean): void {
    this.onboardingBannerHasData = hasData;
    this.cdr.markForCheck();
  }

  onOnboardingBannerFullyCompleted(isFullyCompleted: boolean): void {
    this.onboardingBannerIsFullyCompleted = isFullyCompleted;
    this.cdr.markForCheck();
  }

  private isClientPepRequestedStatus(status: string): boolean {
    return (status ?? '').trim().toLowerCase() === LaftStatus.PepRequested.toLowerCase();
  }

  private startClientOnboardingAwaitingInReview(): void {
    this.clientOnboardingAwaitingInReview = true;
    this.spinner.show();
    if (this.clientOnboardingSpinnerKeepAliveInterval) {
      clearInterval(this.clientOnboardingSpinnerKeepAliveInterval);
    }
    this.clientOnboardingSpinnerKeepAliveInterval = setInterval(() => {
      if (this.clientOnboardingAwaitingInReview) {
        this.spinner.show();
      }
    }, 250);
    if (this.clientOnboardingAwaitingInReviewTimeout) {
      clearTimeout(this.clientOnboardingAwaitingInReviewTimeout);
    }
    this.clientOnboardingAwaitingInReviewTimeout = setTimeout(() => {
      this.clearClientOnboardingAwaitingInReview();
    }, 12000);
    this.cdr.markForCheck();
  }

  private clearClientOnboardingAwaitingInReview(): void {
    this.clientOnboardingAwaitingInReview = false;
    if (this.clientOnboardingAwaitingInReviewTimeout) {
      clearTimeout(this.clientOnboardingAwaitingInReviewTimeout);
      this.clientOnboardingAwaitingInReviewTimeout = null;
    }
    if (this.clientOnboardingSpinnerKeepAliveInterval) {
      clearInterval(this.clientOnboardingSpinnerKeepAliveInterval);
      this.clientOnboardingSpinnerKeepAliveInterval = null;
    }
    this.spinner.hide();
    this.cdr.markForCheck();
  }
}
